import axios from 'axios';
import React from 'react';

class fileUpload extends React.Component {
    constructor(props){
        super(props); 

        this.state = {
            selectedFile: null,
            img: null
        }
    }

    componentDidMount() {
       this.setState({}); 
    }

    onFileChange = event => {
        this.setState({ selectedFile: event.target.files[0] });
    };

    onFileUpload = () => {
        const formData = new FormData();
        formData.append(
            "logo",
            this.state.selectedFile,
            this.state.selectedFile.name
        );

        const headers = {
            'X-Access-Token': this.props.userdata.accessToken
        }

        axios.post(this.props.apiurl + "/api/logo/upload", formData, { headers: headers}).then(res => {
            this.props.handlelogo(res, this.state); 
            this.setState({});  
        }).catch(err => {
            console.log(err); 
        })
    };


    
    render() {
        let file = []; 

        if (this.props.logourl){
            file = 
                <div>                
                    <img src={this.props.logourl} style={{width: "150px", height: "auto"}} className="img-fluid" alt="logo"></img>
                </div>

        }

            


        return (
            <div className="row mb-2">
                <div className="col">
                    <div className="form-group">
                        <label>Logo | </label>
                        <small> Max width 300 pixels max Height 150 pixels</small>
                        <p>Choose image file, then press "upload" button.</p>
                        <input type="file" name="logo" className="form-control-file" onChange={this.onFileChange}  />
                    </div>
                    <button className="btn btn-outline-secondary btn-sm" onClick={this.onFileUpload}>Upload!</button>
                </div>
                <div className="col">
                   {file}
                </div>
            </div>
        );
    }
}

export default fileUpload;
{/*
    <div>
        <h5>File Details:</h5>
        <img src={this.props.logourl} className="img-fluid" alt="logo"></img>
        <p>File Name: {this.state.selectedFile.name}</p>
        <p>File Type: {this.state.selectedFile.type}</p>
        <p>
            Last Modified:{" "}
            {this.state.selectedFile.lastModifiedDate.toDateString()}
        </p>
    </div>
*/}